import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true,
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items || !items.length) {
      return items;
    }
    if (!searchText || searchText.length < 1) {
      return items;
    }

    searchText = searchText.toLowerCase();

    return items.filter(item => {
      return Object.keys(item).some(key => {
        return String(item[key]).toLowerCase().includes(searchText);
      });
    });
  }
}
